<template>
  <router-view />
</template>

<style lang="scss">
@import '@/styles/variables.scss';

@font-face {
  font-family: 'hylia-serif';
  src: url('@/assets/fonts/HyliaSerif.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
}

body {
  font-family: 'hylia-serif', 'Montserrat', sans-serif;
  background: url('@/assets/bg.png') no-repeat center center fixed;
  background-size: cover;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
}

::-webkit-scrollbar {
  width: 3px;
}

::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: $color-background;
  border-radius: 10px;
  border: 2px solid transparent;
}

::selection {
  background: $color-background;
  color: $color-highlight;
}
</style>
